module.exports = __webpack_public_path__ + "assets/moon-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/moon-icon.png
// module id = 1219
// module chunks = 7